export const DEFAULT_BIT_PLOT = {
  get_user_home_data:  null,
  get_user_home_data_loading: false,
  get_user_settings:  null,
  get_user_settings_loading: false,
  buy_land_asset:  null,
  buy_land_asset_loading: false,
  get_user_land_asset:  null,
  get_user_land_asset_pagination:  null,
  get_user_land_asset_loading: false,
  get_user_land_asset_transaction:  null,
  get_individual_user_land_asset: null,
  get_individual_user_land_asset_loading: false,
  get_user_land_asset_transaction_loading: false,
  // ===============================================================
  get_admin_home_data:  null,
  get_admin_home_data_loading: false,
  get_admin_settings:  null,
  get_admin_settings_loading: false,
  update_settings:  null,
  update_settings_loading: false,
  get_land_assets:  null,
  get_land_assets_pagination:  null,
  get_land_assets_loading: false,
  add_land_assets:  null,
  add_land_assets_loading: false,
  get_land_asset_transactions:  null,
  get_land_asset_transactions_pagination: null,
  get_land_asset_transactions_loading: false,
  // ==============================================================
  error: {
    get_user_home_data_error:  null,
    get_user_settings_error:  null,
    buy_land_asset_error:  null,
    get_user_land_asset_error:  null,
    get_individual_user_land_asset_error: null,
    get_user_land_asset_transaction_error:  null,
    // ================================================================
    get_admin_home_data_error:  null,
    get_admin_settings_error:  null,
    update_settings_error:  null,
    get_land_assets_error:  null,
    add_land_assets_error:  null,
    get_land_asset_transactions_error: null, 
  }
}
